import React from "react";

import { hdfcLogo } from "../../utils/images";

const HdfcLogo = () => (
    <header className="py-3 md:py-5 bg-dark-blue fixed w-full z-50">
        <div className="container flex justify-center mx-auto px-5">
            <a href="javascrpt:;" className="logoLink">
                <img src={hdfcLogo} alt="HDFC Bank" title="HDFC Bank" />
            </a>
        </div>
    </header>
);

export default HdfcLogo;
